import { cn } from '../../lib/cn.ts';

export interface LoadingStateProps {
  title?: string;
  description?: string;
  className?: string;
  'data-testid'?: string;
}

function LoadingState({ title, description, className, 'data-testid': testId }: LoadingStateProps) {
  return (
    <div
      data-testid={testId ?? 'loading-state'}
      role="status"
      aria-live="polite"
      aria-label={title ?? 'Loading'}
      className={cn(
        'flex flex-col items-center justify-center gap-4',
        'py-16 px-6 text-center',
        className,
      )}
    >
      {/* Calm minimal spinner — no decorative bounce or pulsing ring */}
      <div
        aria-hidden="true"
        className={cn(
          'h-7 w-7 rounded-full border-2',
          'border-[var(--color-warm-stone-soft)] border-t-[var(--color-warm-stone)]',
          'animate-spin',
        )}
      />
      {(title ?? description) && (
        <div className="flex flex-col gap-1 max-w-sm">
          {title && <p className="text-sm font-medium text-[var(--color-charcoal)]">{title}</p>}
          {description && <p className="text-sm text-[var(--color-stone-mid)]">{description}</p>}
        </div>
      )}
    </div>
  );
}

export { LoadingState };
